import angular from 'angular';
import { getTagColorKey } from '@/shared/components/tag/tagColors';

angular.module('cloudX').directive('cxTagPicker', [
  '$filter',
  '$rootScope',
  'resourceFactorySvc',
  '$q',
  function($filter, $rootScope, resourceFactorySvc, $q) {
    return {
      restrict: 'E',
      replace: true,
      template: `<div>
        <tags-input
          ng-model="selected"
          placeholder="{{placeholder||('Tag'|translate)}}"
          on-tag-added="updateValue()"
          on-tag-removed="updateValue()"
          replace-spaces-with-dashes="false"
          add-from-autocomplete-only="true"
          min-length="1"
          add-on-blur="false"
          tag-class="getTagColorClass($tag)"
          class="bootstrap">
          <auto-complete
            source="loadTags($query)"
            load-on-focus="true"
            load-on-empty="true"
            min-length="0"></auto-complete>
        </tags-input>
      </div>`,
      scope: { placeholder: '@?', retrieveTags: '=?' },
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;
        $scope.selected = [];
        $scope.tags = null;
        $scope.tagColorByName = {};

        var setTagColors = function(data) {
          var map = {};
          (data || []).forEach(function(tag) {
            if (typeof tag.color !== 'undefined' && tag.color !== null) map[tag.name] = tag.color;
          });
          $scope.tagColorByName = map;
        };

        $scope.getTagColorClass = function($tag) {
          var color = $scope.tagColorByName[$tag && $tag.text];
          if (typeof color === 'undefined') return '';
          return 'tag-color-' + getTagColorKey(color);
        };

        $scope.loadTags = function(search) {
          if ($scope.tags !== null) {
            return $filter('filter')($scope.tags, search);
          }

          if ($scope.retrieveTags) {
            return $scope.retrieveTags
              .then(function({ data }) {
                setTagColors(data);
                $scope.tags = data.map(x => ({ text: x.name }));
              })
              .then(function() {
                return $filter('filter')($scope.tags, search);
              });
          } else {
            return resourceFactorySvc
              .get('resource')
              .tags({}, function(data) {
                setTagColors(data);
                $scope.tags = data.map(x => ({ text: x.name }));
              })
              .$promise.then(function() {
                return $filter('filter')($scope.tags, search);
              });
          }
        };

        $scope.getSuggestions = function(search) {
          return $filter('filter')($scope.options, search);
        };

        $scope.updateValue = function() {
          ngModel.$setViewValue($scope.selected.map(x => x.text));
        };

        ngModel.$render = function() {
          var value = ngModel.$viewValue;
          if (value !== null && typeof value !== 'undefined' && angular.isArray(value)) {
            if ($scope.selected.length || value.length)
              $q.when($scope.loadTags()).then(function() {
                $scope.selected = value.map(x => ({ text: x }));
              });
          }
        };
      },
    };
  },
]);
